<template class="step">
   <el-steps :active="active" finish-status="success">
        <el-step title="填写购券信息"></el-step>
        <el-step title="支付"></el-step>
        <el-step description="（使用默认文案无需审核）" :title="text"></el-step>
   </el-steps>
</template>

<script>
export default {
  name: 'Step',
  componentName: 'Step',
  data () {
    return {
      text: this.thirdText ? this.thirdText : '等待审核'
    }
  },
  props: {
    active: Number,
    thirdText: ''
  }
}
</script>

<style lang="stylus">
    .step {
        margin-bottom: 40px;
    }
        .el-steps {
            width : 80%
            
        }
        .el-step__main{
            position: absolute;
            top: 0px;
            left: 20px;
            padding-left: 10px;
            background: #fff;
            height: 24px;
            padding-right:10px;
        }
        .el-step__icon{
            width: 22px;
            height 22px;
        }
        .el-step__title {
            line-height: 24px;
            font-size:14px
        }
        .el-step {
            margin-top:40px
            margin-right: 5px !important;
        }
        .el-step:nth-child(3) .el-step__main {
            width: 160px
        }
        .el-step__line {
            background-color : #cccccc;
            height : 1px;
        }
        .el-step__icon.is-text {
            border: solid 1px #E5E5E5;
        }
        .is-process{
            .el-step__icon{
                background-color : #3468FF
                border-color : #3468FF
                color: #ffffff
            }
        }
        .el-step__title{
            &.is-process{
                color: #333
            }
            &.is-wait{
                color: #999
            }
        }
        .el-step__head.is-success {
            color: #3468ff;
            border-color: #3468ff;
            .el-step__line{
                background-color :#3468ff;
            }
        }
        .el-step__title.is-success {
            font-weight: 700;
            color: #333;
        }
        .is-success {
            .el-step__icon.is-text {
                border-color: #3468ff;
            }
            .el-icon-check {
                color: #3468ff;
            }
        }
        .el-step:last-of-type .el-step__description{
            position: relative;
            left: -50px;
            top: 9px;
        }
        
</style>
